// FormItem.js
import React from "react";
import FormItemOptions from "./FormItemOptions";
import FormItemPlanTypes from "./FormItemPlanTypes";
import FormItemPrice from "./FormItemPrice";
import FormItemQuantity from "./FormItemQuantity";
import FormItemTotal from "./FormItemTotal";

const FormItem = ({
  item,
  isOptionSelected,
  depositFeesId,
  onOptionChange,
  onPlanTypeChange,
  onQuantityChange,
}) => {
  const {
    id,
    name,
    price,
    options,
    planTypes,
    quantity,
    total,
    selectedOption,
  } = item;

  const itemPrice = selectedOption ? selectedOption.price : price || 0;

  const isDepositFeesItem = id === depositFeesId;

  return (
    <div
      key={id}
      className="grid grid-cols-10 gap-2 mb-2 p-2 pb-4 border-b text-end max-w-[700px] print:m-auto"
    >
      <div className="mb-2 col-span-full text-start">
        {!options && (
          <div className="pt-2">
            {name}
            {isOptionSelected && isDepositFeesItem && quantity === 0 && (
              <span className="text-sm ml-2 italic">(Not Applicable)</span>
            )}
          </div>
        )}
        {options && (
          <>
            <div
              className={`${
                selectedOption ? "font-normal" : "font-medium"
              } pt-2`}
            >
              {name}
            </div>
            <FormItemOptions item={item} onOptionChange={onOptionChange} />
            {planTypes && (
              <FormItemPlanTypes
                item={item}
                onPlanTypeChange={onPlanTypeChange}
              />
            )}
          </>
        )}
      </div>
      <FormItemPrice value={itemPrice} />
      <FormItemQuantity
        itemId={item.id}
        maxQuantity={item.maxQuantity}
        quantity={item.quantity}
        isOptionSelected={isOptionSelected}
        isDepositFeesItem={isDepositFeesItem}
        onQuantityChange={onQuantityChange}
      />
      <FormItemTotal total={total} />
    </div>
  );
};

export default FormItem;
